package com.eladfinish.bible.contest.analytics.providers

// Uses AnalyticsProvider's default logEvent, which reports to Firebase Analytics.
private class WebAnalyticsProvider : AnalyticsProvider

actual fun provideAnalyticsProvider(): AnalyticsProvider = WebAnalyticsProvider()
